import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Checkbox from '../controls/checkbox/Checkbox';
import {
  selectUserNotificationEnabled,
  notificationSettingsChanged,
} from '../../store/user-notificaition-settings';

import './UserNotificationSettings.scss';

const UserNotificationSettings = () => {
  const dispatch = useDispatch();
  const userNotificationEnabled = useSelector(selectUserNotificationEnabled);

  const handleCheck = useCallback(
    ({ target: { checked } }) => dispatch(notificationSettingsChanged(checked)),
    [dispatch],
  );

  return (
    <label className="user_notification_settings">
      <Checkbox
        className="user_notification_settings__checkbox"
        checked={userNotificationEnabled}
        onChange={handleCheck}
      />
      Notify me when my issue has been resolved.
    </label>
  );
};

export default UserNotificationSettings;
